module.exports = __webpack_public_path__ + "first-10_uv_back.jpg?894084f83ebda1d5b4c2c7de918eb9bc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-10_uv_back.jpg
// module id = 452
// module chunks = 0